import script from "./AddProductsToCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProductsToCampaign.vue?vue&type=script&setup=true&lang=js"

import "./AddProductsToCampaign.vue?vue&type=style&index=0&id=2e80013b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e80013b"]])

export default __exports__